import { render } from "./Search.vue?vue&type=template&id=5ab56466&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5ab56466"

export default script